import React, { useState, useEffect } from "react";
import { Card, Row, Col, Spinner, Alert } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import "./EmployeeTips.css";
import BaseUrl from "../../ApiServices/BaseUrl";

const EmployeeTips= () => {
  const [categoriesData, setCategoriesData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch tips from backend API
  const fetchTips = async () => {
    try {
      console.log("Fetching tips from API...");
      setLoading(true);
      setError(null);

      const response = await fetch(`${BaseUrl}/api/tips`);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();

      // Transform into category-wise object with full tip objects
      const categorized = {};
      data.forEach((tip) => {
        const key = tip.category || "general"; // fallback category
        if (!categorized[key]) categorized[key] = [];
        categorized[key].push(tip);
      });

      setCategoriesData(categorized);
    } catch (err) {
      console.error("Error fetching tips:", err);
      setError("Failed to load tips. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTips();
  }, []);

  const renderCategoryCard = (categoryKey, categoryName) => (
    <Col md={6} className="mb-4" key={categoryKey}>
      <Card className="shadow-sm border-0 rounded-3 overflow-hidden">
        <Card.Body>
          <h5 className="category-heading">{categoryName}</h5>
          <div className="tips-block">
            {(categoriesData[categoryKey] || []).map((tip) => (
              <div key={tip.id} className="tip-item">
               
                <div className="detail-row">
                  <span className="detail-key title-key">» Title --- : </span>
                  <span className="detail-value title-value">{tip.title}</span>
                  <hr />
                </div>
               
                <div className="detail-row">
                  <span className="detail-key category-key">» Category --- : </span>
                  <span className="detail-value category-value">{tip.category}</span>
                   <hr />
                </div>
              
                <div className="detail-row">
                  <span className="detail-key content-key">» Content --- : </span>
                  <span className="detail-value content-value">{tip.content}</span>
                   <hr />
                </div>
               
                <div className="detail-row">
                  <span className="detail-key excerpt-key">» Excerpt --- : </span>
                  <span className="detail-value excerpt-value">{tip.excerpt}</span>
                   <hr />
                </div>
                
                <div className="detail-row">
                  <span className="detail-key slug-key">» Slug --- : </span>
                  <span className="detail-value slug-value">{tip.slug}</span>
                   <hr />
                </div>
                
                <div className="detail-row">
                  <span className="detail-key meta-key">» Meta Description --- : </span>
                  <span className="detail-value meta-value">{tip.meta_description}</span>
                   <hr />
                </div>

                <div className="detail-row">
                  <span className="detail-key tags-key">» Tags --- : </span>
                  <span className="detail-value tags-value">{tip.tags}</span>
                   <hr />
                </div>
              </div>
            ))}
          </div>
        </Card.Body>
      </Card>
    </Col>
  );

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "200px" }}
      >
        <Spinner animation="border" />
        <span className="ms-2">Loading tips...</span>
      </div>
    );
  }

  if (error) {
    return <Alert variant="danger">{error}</Alert>;
  }

  return (
    <>
      <Card className="p-4 shadow-sm mb-4 border-0">
        <Card.Body className="text-center">
          <h4 className="fw-bold text-primary mb-3">
            Advices and Tips For Employers & Helpers
          </h4>
          <div className="yellow-underline mx-auto mb-3"></div>
          <p className="text-muted mb-0">
            Helpful advice across relationship management, trainings, daily life,
            and support networks for helpers.
          </p>
        </Card.Body>
      </Card>

      <Row className="tips-section">
        {Object.keys(categoriesData).map((categoryKey) => {
          const categoryName = categoryKey
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (str) => str.toUpperCase());
          return renderCategoryCard(categoryKey, categoryName);
        })}
      </Row>
    </>
  );
};

export default EmployeeTips;